/**
 * @architecture-header 1
 * @layer app
 * @domain workspace
 * @responsibility Mount the authenticated product with a host-created router and injected environment.
 * @state-owner app composition only
 * @allowed-imports React Router; app providers/config
 * @forbidden fixed history implementation; host globals; module internals
 * @public-api @vispo/workspace-web
 * @side-effects renders the product tree
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import type { ComponentProps } from 'react';
import { RouterProvider } from 'react-router-dom';
import type { WorkspaceEnvironment } from '../config/environment';
import { WorkspaceProviders } from '../providers/WorkspaceProviders';

export interface WorkspaceRootProps {
  router: ComponentProps<typeof RouterProvider>['router'];
  environment: WorkspaceEnvironment;
}

export function WorkspaceRoot({ router, environment }: WorkspaceRootProps) {
  return (
    <WorkspaceProviders environment={environment}>
      <RouterProvider router={router} />
    </WorkspaceProviders>
  );
}
